var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"divider"},[_c('v-divider',{style:(`margin: ${_vm.margin} 0`)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }